import { FC, useMemo } from "react";
import { Segmented, SegmentedProps } from "antd";
import { useTranslation } from "react-i18next";
import { INITIAL_TRIP_OPTION, TRIP_TYPE_OPTIONS } from "../../../constants";
import classNames from "classnames";

const TripSelection: FC<Omit<SegmentedProps,"options">> = ({value,  ...props}) => {
  const { t, i18n } = useTranslation();
  const options = useMemo(
    () => TRIP_TYPE_OPTIONS.map((option) => ({ ...option, label: t(option.labelKey) })),
    [t, i18n.language],
  );

  return (
    <Segmented
      value={value ?? INITIAL_TRIP_OPTION}
      shape="round"
      seamless={true}
      classNames={{
        root: "p-2! bg-background-default! outline! outline-border-default! w-full!",
        label: "px-7! font-semibold! rounded-full! w-full! p-2!",
        item: "w-full!",
      }}
      {...props}
      options={options}
    />
  );
};

export default TripSelection;
